import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import AuthReducer, { loginSuccess } from "./reducer/AuthReducer";
import BulkOrderReducer from "./reducer/BulkOrder";
import RoomReducer from "./reducer/RoomReducer";
import UserReducer from "./reducer/UserReducer";
import ArtworkReducer from "./reducer/ArtworkReducer";
import ArtworkViewReducer from "./reducer/ArtworkViewReducer";
import ArtworkShareReducer from "./reducer/ArtworkShareReducer";
import TestReducer from "./reducer/TestReducer";
import { logger } from "redux-logger";
import RootSaga from "./ReduxSaga/RootSaga";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    AuthReducer,
    BulkOrderReducer,
    UserReducer,
    RoomReducer,
    ArtworkReducer,
    ArtworkViewReducer,
    ArtworkShareReducer,
    TestReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: ["Artwork/uploadArtworkRequest"],
      },
    }).concat(sagaMiddleware),
});

// ✅ Rehydrate auth state from localStorage
const savedAuth = localStorage.getItem("auth");
if (savedAuth) {
  store.dispatch(loginSuccess(JSON.parse(savedAuth)));
}

// Run saga
sagaMiddleware.run(RootSaga);

export default store;
